module.exports = __webpack_public_path__ + "5e077efda3a1aac78b676ef2e6f2ee41.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/minimal-wave.jpg
 ** module id = 424
 ** module chunks = 0
 **/